<div class="modal-container flex flex-col">
  <ion-header class="flex flex-row items-center justify-between">
    <img src="../../../../assets/images/logo/logo-negro.svg" />
    <ion-button fill="clear" (click)="close()">
      <ion-icon src="../../../../assets/icon/cross.svg"></ion-icon>
    </ion-button>
  </ion-header>

  <h1>¡Comparte tu carrito y gana 💰!</h1>

  <ion-list lines="none" class="flex flex-col gap-2.5 p-2">
    <ng-container *ngFor="let item of shareList">
      <div (click)="clickOn(item.type)" class="flex flex-row items-center justify-center">
        <ion-icon [src]="item.iconName"></ion-icon>
        <ion-label>{{ item.name }}</ion-label>
      </div>
    </ng-container>
  </ion-list>
</div>
